module.exports = __webpack_public_path__ + "static/media/block-dark.0e7d330c.svg";